import $ from 'jquery'


const hamburger = document.querySelector('.haburger-holder')
const nav = document.querySelector('.header-nav')
const closeNav = document.querySelector('.header-nav__close')

hamburger.addEventListener("click", ()=>{
    nav.classList.add('header-nav--active')
});

closeNav.addEventListener("click", ()=>{
    nav.classList.remove('header-nav--active')
});



$('.header-nav-item--has_sumbenu a.header-nav__link-with-submenu').click(function(e){
  let href = $(this).attr('href');
  // on mobile, open dropdown
  if($(window).width() < 1200){
    console.log('mobile')
        event.preventDefault();
        $(this).parent().toggleClass('header-nav-item--has_sumbenu--active')
        return
      } else {
        // on desktop, open dropdown if there is no href of the a
        if(!href){
          $(this).parent().toggleClass('header-nav-item--has_sumbenu--active')
        }
    }
  })



  $('.excursion-section-faq__single-question').click(function(){
    // console.log(this)
    $('.excursion-section-faq__single').each(function(){
      $(this).removeClass('excursion-section-faq__single--active')
    })

    $(this).parent().addClass('excursion-section-faq__single--active')
      // $(".content a").not(this).hide("slow");)
  })

  $(document).click(function() {
    var container = $(".excursion-section-faq__single");
    if (!container.is(event.target) && !container.has(event.target).length) {
      container.removeClass('excursion-section-faq__single--active')
    }
});



$(document).click(function() {
  var container = $(".header-locale-select");
  if (!container.is(event.target) && !container.has(event.target).length) {
    $('#inactive-locales').removeClass('header-locale-select__other-locales--active')
  }
})
